import { CSSProperties, ReactNode } from 'react'

export interface FieldMessageProps {
    variant?: 'description' | 'error'
    children: ReactNode
    style?: CSSProperties
}

export const FieldMessage = ({ variant = 'description', children, style }: FieldMessageProps) => (
    <p className={`m-0 text-xs font-normal leading-4 ${variant === 'error' ? 'text-danger' : 'text-foreground-muted'}`} style={style}>
        {children}
    </p>
)
